// extracted by mini-css-extract-plugin
export default {"fr-view":"Groups_fr-view__Uy2PL","group":"Groups_group__xfdXC"};